import { format, utcToZonedTime } from 'date-fns-tz';

const epochToModifiedFormat = epoch => {
  const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
  const utcTime = utcToZonedTime(epoch * 1000, timeZone);
  return format(utcTime, 'MMMM dd, yyyy @ HH:mm zzz', timeZone);
};

export { epochToModifiedFormat }; // eslint-disable-line
